import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Link, Redirect} from 'react-router-dom'
import {Col, Button, Form, FormGroup, Label, Input, FormText, Alert} from 'reactstrap';
import Recaptcha from 'react-recaptcha';

import {registrationUser} from '../../actions/userActions'
class Registration extends Component {

  constructor(props) {
    super(props);
    this.state = {
        recaptchaVerified: false,
    };
    this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
}
recaptchaLoaded() {
  console.log('Recaptcha loaded successfully');
}

verifyCallback(response) {
  if (response) {
      this.setState({ recaptchaVerified: true });
  }
}

  handleSubmit = (e) => {

    const {login} = this.props.userState

    e.preventDefault();
    let {registrationUser} = this.props
    let data = new FormData(document.querySelector('#registration-form'));
    sessionStorage.setItem("btn_ok", "ok");

    if (login.isLogin) {
      registrationUser(data);
    } else {
      if (this.state.recaptchaVerified) {
        registrationUser(data);
      } else {
        this.setState({ recaptchaVerified: false });
      }
    }

    
  }

    
  render() {
    let {login, registration} = this.props.userState
    return (
      <Form onSubmit={this.handleSubmit} id="registration-form" style={{ "maxWidth": 730 }} className="mx-auto">
        {sessionStorage.getItem("btn_ok")==="ok" && login.isLogin ? <Redirect to="/user" /> : ""}
        {login.isLogin ? <Input type="hidden" name="id" defaultValue={login.data.id} /> : ""}
        {login.isLogin ? 
          <h2 className="text-center mb-4">Modifier votre compte</h2> 
          : 
          <h2 className="text-center mb-4">Créez votre compte</h2>
        }
        {login.isLogin ?
         null
         : 
          <FormGroup row>
          <Col sm={12} className="text-center">
            <p>Vous avez déjà un compte ?<Link to="/login">Connectez-vous !</Link></p>
          </Col>
        </FormGroup>
       }
       
        <FormGroup row>
          <Col sm={3} className="text-right">
            Civilité :
          </Col>
          <Col sm={9}>
            <Label check>
              <Input type="radio" name="id_gender" className="mr-1" value="1" defaultChecked={login.isLogin && login.data.id_gender==='1'  ? true : false}   required/>{'Mr.'}
            </Label>
            <Label check>
              <Input type="radio" name="id_gender" className="ml-2 mr-1" value="2" defaultChecked={login.isLogin && login.data.id_gender==='2'  ? true : false}/>{'Mme'}
            </Label>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="firstName" sm={3} className="text-right">Prénom :</Label>
          <Col sm={9}>
            <Input type="text" name="firstname" id="firstname" defaultValue={login.isLogin ? login.data.firstname : ""} required/>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="lastName" sm={3} className="text-right">Nom :</Label>
          <Col sm={9}>
            <Input type="text" name="lastname" id="lastName" defaultValue={login.isLogin ? login.data.lastname : ""}   required/>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="exampleEmail" sm={3} className="text-right">E-mail :</Label>
          <Col sm={9}>
            <Input type="email" name="email" id="exampleEmail" defaultValue={login.isLogin ? login.data.email : ""}   required/>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="examplePassword" sm={3} className="text-right">Mot de passe :</Label>
          <Col sm={9}>
            <Input type="password" name="passwd" id="examplePassword" required defaultValue={login.isLogin ? login.data.birthday : ""} readOnly={login.isLogin ? true : false} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="Birthdate" sm={3} className="text-right">Date de naissance :</Label>
          <Col sm={9}>
            <Input type="date" name="birthday" id="Birthdate" defaultValue={login.isLogin ? login.data.birthday : ""}   />
            <FormText color="muted">Optionel</FormText>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 9, offset: 3 }}>
            <Label check>
              <Input type="checkbox" name="optin" value="1" defaultChecked={login.isLogin && login.data.optin==='1'  ? true : false}  />{' '}
              Recevoir les offres de nos partenaires
            </Label>
          </Col>
          <Col sm={{ size: 9, offset: 3 }}>
            <Label check>

              <Input type="checkbox" name="newsletter" value="1" defaultChecked={login.isLogin && login.data.newsletter==='1'  ? "1" : false}  />{' '}
              Recevoir notre newsletter
            </Label>
          </Col>
        </FormGroup>
        <FormGroup check row>
        <Col sm={{ size: 9, offset: 3 }}>
          {login.isLogin ? (
            <div>
              <Button color="primary" type="submit">
                Mise à jour
              </Button>
              <Link to="/user" className="ml-2 btn btn-primary">
                Retour
              </Link>
            </div>
          ) : (
            <div>
            <Recaptcha
                  sitekey="6LcP5z4pAAAAAIDhHElH--sdYuF-7iJBaZTgnSME"
                  render="explicit"
                  onloadCallback={this.recaptchaLoaded}
                  verifyCallback={this.verifyCallback}
                  hl="fr"
            />
            <Button color="primary" type="submit" className="mt-2 text-center">
              Enregistrer
            </Button>
            </div>
            
          )}
        </Col>

        </FormGroup>
        {registration.fetching ?
          <Alert color="info" className="mt-4">
            <p className="text-center">Chargement en cours ...</p>
          </Alert>
          : null
        }
        {registration.message.show ?
          <Alert color="warning" className="mt-4">
            {registration.message.text}
          </Alert>
          : null
        }
      </Form>
    );
  }
}

function mapStateToProps({userReducer}) {
  return {
    userState: userReducer
  }
}
function mapDispatchToProps(dispatch) {
  return {
    registrationUser: bindActionCreators(registrationUser, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Registration);


// WEBPACK FOOTER //
// ./src/containers/User/Registration.js